export function SummaryBannerContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="shrink-0 px-4 py-3 border-b border-primary-border">
      {children}
    </div>
  )
}
